import { render, staticRenderFns } from "./PlaceCardv2Restaurant.vue?vue&type=template&id=baf9a74c&scoped=true"
import script from "./PlaceCardv2Restaurant.vue?vue&type=script&lang=js"
export * from "./PlaceCardv2Restaurant.vue?vue&type=script&lang=js"
import style0 from "./PlaceCardv2Restaurant.vue?vue&type=style&index=0&id=baf9a74c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf9a74c",
  null
  
)

export default component.exports